import React, { useState } from 'react';

import CreateModule from './CreateModule';
import CreateVersion from './CreateVersion';
import './index.scss';
import DeleteModal from './DeleteModal';
import useHandleOperation from '../hooks/useHandleOperation';
import { VisibleType, ParamsType } from '../type';

interface FormModelPopupProps {
  params: any;
  visible?: VisibleType;
  handleApiStatus: (status?: 'success' | 'error') => void;
  gameInfo: any;
  closeModal: () => void; 
  type?: ParamsType;
}

export default function FormModelPopup({
  type,
  params,
  visible,
  handleApiStatus,
  gameInfo,
  closeModal,
}: FormModelPopupProps) {
  const { confirmDelete, loading, handleModules, handleVersion } =
    useHandleOperation({
      callBack: handleApiStatus,
      gameInfo,
      params,
      type,
      closeModal,
    });

  // 弹窗的必填值状态
  const [inputContentStatus, setInputContentStatus] = useState(false);

  const renderPopup = () => {
    if (!visible) {
      return null;
    }

    if (visible === 'delete') {
      return (
        <DeleteModal
          closeDeleteModal={closeModal}
          type={type!}
          loading={loading}
          deleteName={
            type === 'version' ? params.version_name : params.module_name
          }
          confirmDelete={confirmDelete}
        ></DeleteModal>
      );
    }

    if (type === 'version') {
      return (
        <CreateVersion
          data={params}
          handleVersion={handleVersion}
          loading={loading}
          closeModal={closeModal}
          inputContentStatus={inputContentStatus}
          gameInfo={gameInfo}
          handleInputContentStatus={(value) => setInputContentStatus(value)}
        />
      );
    }

    return (
      <CreateModule
        data={params}
        handleModules={handleModules}
        loading={loading}
        closeModal={closeModal}
        inputContentStatus={inputContentStatus}
        handleInputContentStatus={(value) => setInputContentStatus(value)}
        gameInfo={gameInfo}
      />
    );
  };

  return <>{renderPopup()}</>;
}
